/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-28T10:15:19+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-10-06T16:37:15+02:00
*/
import isEmailValidator from 'validator/lib/isEmail';
import trim from 'validator/lib/trim';

export function requireString(value) {
  return !(typeof value !== 'string' || !value.length || !value.trim().length);
}

export function requireStringWithFormat(format, value) {
  return !(typeof value == 'string' && value !== '' && !value.match(format));
}

export function maxLength(max, value) {
  if (value !== null && typeof value !== 'string') {
    return false;
  }
  return !(value !== null && value.length > max);
}

export function hasToBeTrue(value) {
  return !(value === false || typeof value !== 'boolean');
}

export function requireBoolean(value) {
  return typeof value === 'boolean';
}

export function requireNumber(value) {
  return !(typeof value !== 'number' || Number.isNaN(value));
}

export function requireDate(value) {
  return !(value === null ||
    typeof value !== 'object' ||
    typeof value.getTime !== 'function' ||
    Number.isNaN(value.getTime()));
}

export function isEmail(value) {
  if (!value || typeof value !== 'string') {
    return false;
  }
  return isEmailValidator(
      trim(value)
  );
}

